import {match} from 'ts-pattern';

import {FinancialProductType} from '@dms/api/shared';
import i18n from '@dms/i18n';

export const getFinancialProductTypeLabel = (type: FinancialProductType) =>
  match(type)
    .with('STANDARD', () => i18n.t('page.vehicle.financingAndLeasing.standard'))
    .with('BALLOON', () => i18n.t('page.vehicle.financingAndLeasing.balloon'))
    .with('LEASING', () => i18n.t('entity.vehicle.labels.leasing'))
    .exhaustive();
